<template>
  <div class="bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('systemManagement') }} > {{ $t('integratSystemManage') }}</div>
    <div class="common-table-cnt">
      <div class="search search-container">
        <!-- 查询表单 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('systemName')">
            <el-input v-model="formInline.systemName" clearable :placeholder="$t('systemName')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('systemLink')">
            <el-input v-model="formInline.systemUrl" clearable :placeholder="$t('systemLink')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('accessType')">
            <el-select
              v-model="formInline.accessType"
              clearable
              :placeholder="$t('accessType')"
              :popper-append-to-body="false"
            >
              <el-option v-for="item of fileType" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('enableStatus')">
            <el-select
              v-model="formInline.systemStatus"
              clearable
              :placeholder="$t('enableStatus')"
              :popper-append-to-body="false"
            >
              <el-option :label="$t('enable')" :value="1">{{ $t('enable') }}</el-option>
              <el-option :label="$t('disable')" :value="0">{{ $t('disable') }}</el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" class="serachBtn" @click="getList">{{ $t('query') }}</el-button>
            <el-button type="primary" class="serachBtn letter_delet" @click="addSystem" v-if="loginIsAdmin == '1'">{{
              $t('newlyAded')
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- table 表格 -->
      <div class="table-box">
        <Table
          :data="tableData"
          :columns="columns"
          :operation="dateOperation"
          @getList="getList"
          @operate="operationEvent"
          :currentPage="currentPage"
          :pageSize="pageSize"
          :showSelcet="false"
          ref="tanleAssembly"
          :operationWidth="120"
          @sortChange="handleSort"
        ></Table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
    <!--新增或编辑-->
    <el-dialog
      :title="isEdit ? $t('editingSystem') : $t('addSystem')"
      :visible.sync="systemVisible"
      :append-to-body="true"
      class="system-dialog common-blue-contain"
      :close-on-click-modal="false"
      width="520px"
    >
      <el-form :model="systemForm" ref="systemForm">
        <el-form-item :label="$t('systemName')" :label-width="formLabelWidth" required>
          <el-input
            v-model="systemForm.systemName"
            autocomplete="off"
            :placeholder="$t('pleaseEnter') + $t('systemName')"
            maxlength="6"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('systemLink')" :label-width="formLabelWidth" required>
          <el-input
            v-model="systemForm.systemUrl"
            autocomplete="off"
            :placeholder="$t('pleaseEnter') + $t('systemLink')"
          ></el-input>
          <div class="stay-tip">
            {{ $t('httpTip') }}
          </div>
        </el-form-item>
        <el-form-item :label="$t('accessType')" :label-width="formLabelWidth" required>
          <el-select
            v-model="systemForm.accessType"
            clearable
            :placeholder="$t('accessType')"
            :popper-append-to-body="false"
          >
            <el-option v-for="item of fileType" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('menuSorting')" :label-width="formLabelWidth" required>
          <el-input
            v-model="systemForm.systemSort"
            autocomplete="off"
            :placeholder="$t('pleaseEnter') + $t('menuSorting')"
            type="number"
          ></el-input>
          <div class="stay-tip">
            {{ $t('sortTip') }}
          </div>
        </el-form-item>
        <el-form-item :label="$t('enableStatus')" :label-width="formLabelWidth" required>
          <el-select
            v-model="systemForm.systemStatus"
            clearable
            :placeholder="$t('enableStatus')"
            :popper-append-to-body="false"
          >
            <el-option :label="$t('enable')" :value="1">{{ $t('enable') }}</el-option>
            <el-option :label="$t('disable')" :value="0">{{ $t('disable') }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('remarks')" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            v-model="systemForm.description"
            autocomplete="off"
            :placeholder="$t('PleaseFillRemarks')"
            maxlength="300"
            show-word-limit
            clearable
            :autosize="{ minRows: 3 }"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveForm('systemForm')">{{ $t('determine') }}</el-button>
        <el-button @click="cancelForm('systemForm')">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 引入table组件
import Table from '@/components/NewTable'
import { systemPage, updatedSystem, systemAdd, deleteSystem } from '@/api/new-device/intSystem'
import { errorMessage } from '@/util/common'
export default {
  data() {
    return {
      loginIsAdmin: sessionStorage.getItem('isAdmin'),
      // 表单查询字段
      formInline: {
        pageNum: 1,
        pageSize: 10,
      },
      // 当前页
      currentPage: 1,
      // 当前 条/页
      pageSize: 10,
      // 所有数据总条数
      totalData: 0,
      columns: [],
      dateOperation: [],
      tableData: [],
      formLabelWidth: '120px',
      // 查询 ‘模式’的类型
      fileType: [
        { value: 0, label: this.$t('displayWithinSystem') },
        { value: 1, label: this.$t('newTabAccess') },
      ],
      systemVisible: false,
      isEdit: false,
      systemForm: {
        systemName: '',
        systemUrl: '',
        description: '',
        systemSort: null,
        systemStatus: 1,
        accessType: 1,
      },
    }
  },
  components: {
    Table,
  },
  methods: {
    // 排序
    handleSort(data) {
      this.formInline.sortColName = !data.order ? null : data.prop
      this.formInline.useAsc = data.order=== "descending" ? 0 : 1
      this.getList()
    },
    // 点击新增
    addSystem() {
      this.isEdit = false
      this.systemForm = {
        systemName: '',
        systemUrl: '',
        description: '',
        systemSort: 0,
        systemStatus: 1,
        accessType: 1,
      }
      this.systemVisible = true
    },
    // 提交表单
    saveForm() {
      if (this.systemForm.systemName === '') {
        errorMessage(this.$t('pleaseEnter') + this.$t('systemName'))
        return
      } else if (this.systemForm.systemUrl === '') {
        errorMessage(this.$t('pleaseEnter') + this.$t('systemLink'))
        return
      } else if (!this.systemForm.systemUrl.includes('http')) {
        errorMessage(this.$t('pleaseEnter') + '正确'+this.$t('systemLink'))
        return
      } else if (this.systemForm.accessType+'' === '') {
        errorMessage(this.$t('pleaseEnter') + this.$t('accessType'))
        return
      } else if (this.systemForm.accessType+'' === '0' && !this.systemForm.systemUrl.includes('https')) {
        errorMessage(this.$t('errTip') )
        return
      }else if (this.systemForm.systemSort+'' === '') {
        errorMessage(this.$t('pleaseEnter') + this.$t('menuSorting'))
        return
      } else if (this.systemForm.systemStatus+'' === '') {
        errorMessage(this.$t('pleaseEnter') + this.$t('enableStatus'))
        return
      } else {
        if (this.isEdit) {
          // 编辑提交
          updatedSystem(this.systemForm).then(res => {
            if (res.state === 0) {
              this.systemVisible = false
              this.basicConfig()
            }
          })
        } else {
          // 新增提交
          systemAdd(this.systemForm).then(res => {
            if (res.state === 0) {
              this.systemVisible = false
              this.basicConfig()
            }
          })
        }
      }
    },
    // 点击取消
    cancelForm() {
      this.systemVisible = false
    },
    // 操作按钮
    operationEvent(row, value, index) {
      console.log(row, value, index)

      if (row.type === 'delect') {
        // 删除
        this.deleteSystem(row.value)
      } else if (row.type === 'edit') {
        // 编辑
        this.systemForm = row.value
        this.systemForm = {
          systemName: row.value.systemName,
          systemUrl: row.value.systemUrl,
          description: row.value.description,
          systemSort: row.value.systemSort,
          systemStatus: row.value.systemStatus,
          accessType: row.value.accessType,
          id: row.value.id,
        }
        this.isEdit = true
        this.systemVisible = true
      }
    },
    // 调用删除
    deleteSystem(value) {
      this.$confirm(this.$t('confirmDelete'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      }).then(() => {
        deleteSystem({ id: value.id }).then(res => {
          if (res.state === 0) {
            this.basicConfig()
          }
        })
      })
    },
    handleSizeChange(val) {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.pageSize = val
      this.basicConfig()
    },
    handleCurrentChange(val) {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = val
      this.basicConfig()
    },
    // 查询
    getList() {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = 1
      this.basicConfig()
    },
    // 基础配置数据
    basicConfig() {
      systemPage(this.formInline).then(res => {
        if (res.state === 0) {
          this.tableData = res.data.list
          this.tableData.map(item => {
            if (item.accessType === 1) {
              item.accessContent = this.$t('newTabAccess')
            } else {
              item.accessContent = this.$t('displayWithinSystem')
            }
            if (item.systemStatus === 1) {
              item.statusContent = this.$t('enable')
            } else {
              item.statusContent = this.$t('disable')
            }
          })
          this.totalData = res.data.total
        }
      })
      // table 表头配置数据
      this.columns = [
        {
          attrName: 'systemName',
          label: this.$t('systemName'),
          sort: 'systemName',
        },
        {
          attrName: 'systemUrl',
          label: this.$t('systemLink'),
          sort: 'systemUrl',
        },
        {
          attrName: 'systemSort',
          label: this.$t('menuSorting'),
          sort: 'systemSort',
        },
        {
          attrName: 'accessContent',
          label: this.$t('accessType'),
          align: 'center',
          width: '120',
        },
        {
          attrName: 'statusContent',
          label: this.$t('enableStatus'),
          align: 'center',
          width: '130',
        },
      ]
      // table 操作栏配置
      if (this.loginIsAdmin === '1') {
        this.dateOperation = [
          {
            operateName: this.$t('edit'),
            type: 'edit',
            IsHad: '',
            class: 'editClick',
          },
          {
            operateName: this.$t('delete'),
            type: 'delect',
            IsHad: '',
            class: 'editClick',
          },
        ]
      }
    },
  },
  created() {
    this.basicConfig()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
>>>.el-table
  height 640px!important
  min-height 500px!important;/* no */
  overflow: auto
.stay-tip
  line-height 28px
  font-style italic
  color #409eff
.bg-contain .common-table-cnt /deep/ .el-table {
  height: 640px !important
}
.common-blue-contain
  .el-pagination
    margin-top 18px
</style>
